// eslint-disable-next-line no-unused-vars
import { sendRequest } from "./apiServices/apiConnector";

export const service_fetchLanguages = () => {
	return sendRequest(`/language/`).then(response => response.json());
};
